<template>
  <div class="m-edition-section-navigation-menu">
    <AtomEditionSectionNavigationMenu
      :itemsAsideMenu="itemsAsideMenu"
      @showModal="$modal.showModal"
      :show-loading-state="showLoadingState"
      @updateElement="updateElement"
    />
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionSectionNavigationMenu',

  props: {
    contenido: String,
    element: Object,
    showLoadingState: Number
  },

  data () {
    return {
      academyItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'fas fa-users',
          required: false,
          subject: `${this.$t('mEditionMenu.academy.users.subject')}`,
          text: `${this.$t('mEditionMenu.academy.users.text')}`,
          to: `/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.users.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-paper-plane',
          required: false,
          subject: `${this.$t('mEditionMenu.academy.invitations.subject')}`,
          text: `${this.$t('mEditionMenu.academy.invitations.text')}`,
          to: `/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.invitations.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-cog',
          required: false,
          subject: `${this.$t('mEditionMenu.academy.configuration.subject')}`,
          text: `${this.$t('mEditionMenu.academy.configuration.text')}`,
          to: `/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.configuration.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-clipboard-list',
          required: false,
          subject: `${this.$t('mEditionMenu.academy.data.subject')}`,
          text: `${this.$t('mEditionMenu.academy.data.text')}`,
          to: `/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.data.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-file-contract',
          required: false,
          subject: `${this.$t('mEditionMenu.academy.legals.subject')}`,
          text: `${this.$t('mEditionMenu.academy.legals.text')}`,
          to: `/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.legals.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-address-card',
          required: false,
          subject: `${this.$t('mEditionMenu.academy.autoresponders.subject')}`,
          text: `${this.$t('mEditionMenu.academy.autoresponders.text')}`,
          to: `/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.autoresponders.subject')}`
        }
      ],

      accountItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'far fa-smile',
          required: false,
          subject: `${this.$t('mEditionMenu.account.profile.subject')}`,
          text: `${this.$t('mEditionMenu.account.profile.text')}`,
          to: `/${this.$t('rPaths.account')}/${this.$t('mEditionMenu.account.profile.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-lock-alt',
          required: false,
          subject: `${this.$t('mEditionMenu.account.security.subject')}`,
          text: `${this.$t('mEditionMenu.account.security.text')}`,
          to: `/${this.$t('rPaths.account')}/${this.$t('mEditionMenu.account.security.subject')}`
        }
      ],

      assetItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'far fa-window-maximize',
          required: false,
          subject: `${this.$t('mEditionMenu.asset.card.subject')}`,
          text: `${this.$t('mEditionMenu.asset.card.text')}`,
          to: `/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.card.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-file-alt',
          required: false,
          subject: `${this.$t('mEditionMenu.asset.contents.subject')}`,
          text: `${this.$t('mEditionMenu.asset.contents.text')}`,
          to: `/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.contents.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-calendar-alt',
          required: false,
          subject: `${this.$t('mEditionMenu.asset.activation.subject')}`,
          text: `${this.$t('mEditionMenu.asset.activation.text')}`,
          to: `/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.activation.subject')}/${this.$t('mEditionMenu.asset.activation.children.activate.subedition')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-users',
          required: false,
          subject: `${this.$t('mEditionMenu.asset.signedStudents.subject')}`,
          text: `${this.$t('mEditionMenu.asset.signedStudents.text')}`,
          to: `/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.signedStudents.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-comments',
          required: false,
          subject: `${this.$t('mEditionMenu.asset.comments.subject')}`,
          text: `${this.$t('mEditionMenu.asset.comments.text')}`,
          to: `/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.comments.subject')}`
        }
      ],

      billingItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'fas fa-file-invoice-dollar',
          required: false,
          subject: `${this.$t('mEditionMenu.billing.mySales.subject')}`,
          text: `${this.$t('mEditionMenu.billing.mySales.text')}`,
          to: `/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.mySales.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-map-marker-alt',
          required: false,
          subject: `${this.$t('mEditionMenu.billing.salesData.subject')}`,
          text: `${this.$t('mEditionMenu.billing.salesData.text')}`,
          to: `/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.salesData.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-credit-card',
          required: false,
          subject: `${this.$t('mEditionMenu.billing.paymentMethods.subject')}`,
          text: `${this.$t('mEditionMenu.billing.paymentMethods.text')}`,
          to: `/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.paymentMethods.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-address-card',
          required: false,
          subject: `${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}`,
          text: `${this.$t('mEditionMenu.billing.fiscalAuthorizer.text')}`,
          to: `/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-play-circle',
          required: false,
          subject: `${this.$t('mEditionMenu.billing.myPayments.subject')}`,
          text: `${this.$t('mEditionMenu.billing.myPayments.text')}`,
          to: `/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}`
        }
      ],

      mapItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'far fa-window-maximize',
          required: false,
          subject: `${this.$t('mEditionMenu.map.card.subject')}`,
          text: `${this.$t('mEditionMenu.map.card.text')}`,
          to: `/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.card.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-route',
          required: false,
          subject: `${this.$t('mEditionMenu.map.path.subject')}`,
          text: `${this.$t('mEditionMenu.map.path.text')}`,
          to: `/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.path.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-calendar-alt',
          required: false,
          subject: `${this.$t('mEditionMenu.map.activation.subject')}`,
          text: `${this.$t('mEditionMenu.map.activation.text')}`,
          to: `/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.activation.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-users',
          required: false,
          subject: `${this.$t('mEditionMenu.map.enrollments.subject')}`,
          text: `${this.$t('mEditionMenu.map.enrollments.text')}`,
          to: `/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.enrollments.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-file-check',
          required: false,
          subject: `${this.$t('mEditionMenu.map.tasks.subject')}`,
          text: `${this.$t('mEditionMenu.map.tasks.text')}`,
          to: `/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.tasks.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-comments',
          required: false,
          subject: `${this.$t('mEditionMenu.map.messages.subject')}`,
          text: `${this.$t('mEditionMenu.map.messages.text')}`,
          to: `/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.messages.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-map',
          required: false,
          subject: `${this.$t('mEditionMenu.map.chart.subject')}`,
          text: `${this.$t('mEditionMenu.map.chart.text')}`,
          to: `/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.chart.subject')}`
        }
      ],

      filters: {
        limite: 1000000
      },

      productItemsAsideMenu: [
        {
          active: false,
          class: '',
          icon: 'far fa-window-maximize',
          required: false,
          subject: `${this.$t('mEditionMenu.product.card.subject')}`,
          text: `${this.$t('mEditionMenu.product.card.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.card.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-list-alt',
          required: false,
          subject: `${this.$t('mEditionMenu.product.assetsIncluded.subject')}`,
          text: `${this.$t('mEditionMenu.product.assetsIncluded.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.assetsIncluded.subject')}/${this.$t('mEditionMenu.product.assetsIncluded.children.assets.subedition')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-satellite',
          required: false,
          subject: `${this.$t('mEditionMenu.product.satellitesIncluded.subject')}`,
          text: `${this.$t('mEditionMenu.product.satellitesIncluded.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.satellitesIncluded.subject')}/${this.$t('mEditionMenu.product.satellitesIncluded.children.juedroop.subedition')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-brain',
          required: false,
          subject: `${this.$t('mEditionMenu.product.artificialIntelligence.subject')}`,
          text: `${this.$t('mEditionMenu.product.artificialIntelligence.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.artificialIntelligence.subject')}/${this.$t('mEditionMenu.product.artificialIntelligence.children.mensual.subedition')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-money-check-alt',
          required: false,
          subject: `${this.$t('mEditionMenu.product.pricesAndPlans.subject')}`,
          text: `${this.$t('mEditionMenu.product.prices.text')}`,
          to: ''
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-barcode',
          required: false,
          subject: `${this.$t('mEditionMenu.product.discountCodes.subject')}`,
          text: `${this.$t('mEditionMenu.product.discountCodes.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.discountCodes.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-code',
          required: false,
          subject: `${this.$t('mEditionMenu.product.trackingCodes.subject')}`,
          text: `${this.$t('mEditionMenu.product.trackingCodes.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.trackingCodes.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'fas fa-bullhorn',
          required: false,
          subject: `${this.$t('mEditionMenu.product.salesLetters.subject')}`,
          text: `${this.$t('mEditionMenu.product.salesLetters.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.salesLetters.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-handshake',
          required: false,
          subject: `${this.$t('mEditionMenu.product.pagesOfGratefulness.subject')}`,
          text: `${this.$t('mEditionMenu.product.pagesOfGratefulness.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.pagesOfGratefulness.subject')}`
        },

        {
          active: false,
          class: '',
          icon: 'far fa-address-card',
          required: false,
          subject: `${this.$t('mEditionMenu.product.autorespondersLists.subject')}`,
          text: `${this.$t('mEditionMenu.product.autorespondersLists.text')}`,
          to: `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.autorespondersLists.subject')}`
        }
      ]
    }
  },

  computed: {
    academiaConfiguracionGlobal () {
      return Object.assign({}, this.$store.getters.getAcademyGlobalConfiguration)
    },

    academiaId () {
      return this.$store.getters.getAcademyData.id
    },

    itemsAsideMenu () {
      let menu = []
      switch (this.$route.meta.isEdition) {
        case 'academy':
          menu = this.academyItemsAsideMenu
          break

        case 'account':
          menu = this.accountItemsAsideMenu
          break

        case 'asset':
          menu = this.assetItemsAsideMenu
          break

        case 'billing':
          menu = this.billingItemsAsideMenu.filter(item => {
            if (item.subject === this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')) {
              return this.academiaId === configApp.vidroopAcademyId
            }
            return true
          })
          break

        case 'map':
          menu = this.mapItemsAsideMenu
          break

        case 'product':
          menu = this.productItemsAsideMenu.filter(item => {
            if (item.subject === this.$t('mEditionMenu.product.satellitesIncluded.subject')) {
              return this.academiaId === configApp.vidroopAcademyId
            }
            // La IA se incluye como un satelite mas (solo la academia Vidroop) y, hasta que su venta
            // salga, queda detras del interruptor de los Ajustes de IA
            if (item.subject === this.$t('mEditionMenu.product.artificialIntelligence.subject')) {
              return this.academiaId === configApp.vidroopAcademyId &&
                this.$iaVisible.visible
            }
            return true
          })
          break
      }
      return menu
    },

    nodes () {
      return [...this.$store.getters.getAssetNodes]
    },

    section () {
      return this.$route.meta.isEdition === 'asset' || this.$route.meta.isEdition === 'product' || this.$route.meta.isEdition === 'map'
        ? `${this.$route.meta.isEdition}s`
        : this.$route.meta.isEdition
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    $route (to, from) {
      this.setItemAsideClasses()
    },

    academiaConfiguracionGlobal: {
      deep: true,

      handler () {
        this.setAcademyItemsAsideMenuRequired()
      }
    },

    contenido () {
      this.readContenidoEntregables()
    },

    element () {
      if (this.$route.meta.isEdition === 'asset' || this.$route.meta.isEdition === 'map') {
        this.setAssetItemsAsideMenuRequired()
      } else if (this.$route.meta.isEdition === 'product') {
        this.setProductItemsAsideMenuRequired()
      }
    },

    nodes () {
      this.setAssetItemsAsideMenuRequired()
    },

    'productItemsAsideMenu': {
      immediate: true,
      deep: true,
      handler () {
        const prices = this.getProductItem('pricesAndPlans')

        if (!prices) {
          return
        }

        if (this.academiaId === configApp.vidroopAcademyId) {
          prices.to = `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.pricesAndPlansVidroop.subject')}`
        } else {
          prices.to = `/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.pricesAndPlans.subject')}`
        }
      }
    },

    updatedData () {
      if (this.$modal.methodToRun === 'readContenidoEntregables') {
        this.readContenidoEntregables()
      }
    }
  },

  created () {
    this.setItemAsideClasses()
    if (this.$route.meta.isEdition === 'academy' || this.$route.meta.isEdition === 'billing') {
      this.$license.readAcademiaConfiguracionGlobal()
    }
  },

  methods: {
    setAcademyItemsAsideMenuRequired () {
      if (Object.keys(this.academiaConfiguracionGlobal).length) {
        this.academyItemsAsideMenu[2].required = !this.academiaConfiguracionGlobal.academia.datosGenerales
        this.academyItemsAsideMenu[3].required = !this.academiaConfiguracionGlobal.academia.datosDePersona
        this.academyItemsAsideMenu[4].required = !this.academiaConfiguracionGlobal.academia.textosLegales
        this.billingItemsAsideMenu[1].required = !this.academiaConfiguracionGlobal.gestion.puntosDeVenta
        this.billingItemsAsideMenu[2].required = !this.academiaConfiguracionGlobal.gestion.mediosDePago
      }
    },

    readContenidoEntregables () {
      this.$services.read('contenido', 'readContenidoEntregables', {}, [this.contenido], this.filters)
        .then(response => {
          console.log(response.data.entregables)
          this.assetItemsAsideMenu[2].required = !(response.data.entregables.length && response.data.entregables.some(ent => ent.nodos.length))
        })
        .catch(error => {
          console.log(error)
        })
    },

    setAssetItemsAsideMenuRequired () {
      this.assetItemsAsideMenu[0].required = this.element.descripcion === undefined
      this.assetItemsAsideMenu[1].required = this.nodes.length === 0
    },

    setItemAsideClasses () {
      this.itemsAsideMenu.forEach(itemAside => {
        if (itemAside.subject === this.$route.params.subject) {
          itemAside.class = `m-item-aside-active m-item-aside-${this.section}-active`
          // itemAside.icon = itemAside.icon.replace('far', 'fas')
        } else {
          itemAside.class = `m-item-aside-${this.section}`
          // itemAside.icon = itemAside.icon.replace('fas', 'far')
        }
      })
    },

    /**
     * Busca un item del menu del producto por su subject y no por su posicion, para que agregar o
     * mover items no rompa nada silenciosamente.
     */
    getProductItem (key) {
      const subject = this.$t(`mEditionMenu.product.${key}.subject`)

      return this.productItemsAsideMenu.find(item => item.subject === subject)
    },

    setProductItemsAsideMenuRequired () {
      const card = this.getProductItem('card')
      const assets = this.getProductItem('assetsIncluded')
      const prices = this.getProductItem('pricesAndPlans')

      if (card) {
        card.required = this.element.descripcion === undefined
      }

      if (assets) {
        assets.required = this.element.proyectos.length === 0
      }

      if (prices) {
        prices.required = !this.element.activo &&
          !(this.element.producto_vidroop && this.element.cambio_plan)
      }
    },

    updateElement (event) {
      this.element = event
    }
  }
}
</script>
